var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEditableField } from './use-editable-field';
export var useAudienceClients = function () {
    var NEW_CLIENTS_DEFAULT_WEEKS = 6;
    var _a = useEditableField('audiences'), audiences = _a.field, setAudiences = _a.setValue;
    var _b = audiences.value, newClients = _b.newClients, barbers = _b.barbers, shops = _b.shops;
    var setNewClients = function (value) {
        setAudiences(__assign(__assign({}, audiences.value), { newClients: __assign(__assign({}, newClients), { enabled: value, weeks: !value ? NEW_CLIENTS_DEFAULT_WEEKS : newClients.weeks }) }));
    };
    var setNewClientsWeeks = function (weeks) {
        setAudiences(__assign(__assign({}, audiences.value), { newClients: __assign(__assign({}, newClients), { weeks: parseInt(weeks, 10) }) }));
    };
    var setProspective = function (value) {
        setAudiences(__assign(__assign({}, audiences.value), { prospective: { enabled: value } }));
    };
    var setRegular = function (value) {
        setAudiences(__assign(__assign({}, audiences.value), { regular: { enabled: value } }));
    };
    var setLapsing = function (value) {
        setAudiences(__assign(__assign({}, audiences.value), { lapsing: { enabled: value } }));
    };
    var setClientsByService = function (serviceId, enabled) {
        setAudiences(__assign(__assign({}, audiences.value), { service: { serviceId: serviceId, enabled: enabled } }));
    };
    var setBarbersClients = function (barberId, enabled) {
        var _a;
        setAudiences(__assign(__assign({}, audiences.value), { barbers: __assign(__assign({}, barbers), (_a = {}, _a[barberId] = { enabled: enabled }, _a)) }));
    };
    var setShopClients = function (shopId, enabled) {
        var _a;
        setAudiences(__assign(__assign({}, audiences.value), { shops: __assign(__assign({}, shops), (_a = {}, _a[shopId] = { enabled: enabled }, _a)) }));
    };
    return {
        audiences: audiences,
        setNewClients: setNewClients,
        setNewClientsWeeks: setNewClientsWeeks,
        setProspective: setProspective,
        setRegular: setRegular,
        setLapsing: setLapsing,
        setClientsByService: setClientsByService,
        setBarbersClients: setBarbersClients,
        setShopClients: setShopClients,
    };
};
